import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface NavLinkProps {
  to: string;
  end?: boolean;
  className?: string;
  activeClassName?: string;
  children: ReactNode;
  onMouseEnter?: () => void;
  onFocus?: () => void;
}

export function NavLink({ 
  to, 
  end = false, 
  className, 
  activeClassName, 
  children,
  onMouseEnter,
  onFocus
}: NavLinkProps) {
  const location = useLocation();
  const isActive = end 
    ? location.pathname === to 
    : location.pathname.startsWith(to);

  return (
    <Link
      to={to}
      className={cn(
        className,
        isActive && activeClassName
      )}
      onMouseEnter={onMouseEnter}
      onFocus={onFocus}
    >
      {children}
    </Link>
  );
}
